import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { Plus, Edit, Trash2, Search } from 'lucide-react';

const RejectionReasons = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({ reason: '', category: 'quality' });

  useEffect(() => { fetchData(); }, []);
  const fetchData = async () => { try { const r = await api.get('/production/rejection-reasons'); setItems(r.data); } catch(e){} finally { setLoading(false); } };

  const openCreate = () => { setEditing(null); setFormData({ reason: '', category: 'quality' }); setShowModal(true); };
  const openEdit = (d) => { setEditing(d); setFormData({ reason: d.reason, category: d.category || 'general' }); setShowModal(true); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(`/production/rejection-reasons/${editing.id}`, formData);
      else await api.post('/production/rejection-reasons', formData);
      setShowModal(false); fetchData();
    } catch (err) { alert(err.response?.data?.detail || 'Failed'); }
  };

  const handleDelete = async (id, reason) => {
    if (!window.confirm(`Delete "${reason}"?`)) return;
    try { await api.delete(`/production/rejection-reasons/${id}`); fetchData(); } catch(e) { alert(e.response?.data?.detail || 'Failed'); }
  };

  const categories = ['quality', 'dimensional', 'surface', 'material', 'process', 'general'];
  const filtered = items.filter(d => d.reason?.toLowerCase().includes(searchTerm.toLowerCase()) || d.code?.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div data-testid="rejection-reasons-page">
      <div className="flex items-center justify-between mb-4">
        <h1 style={{ fontSize: '24px', fontWeight: 700, margin: 0 }}>Rejection Reasons</h1>
        <button onClick={openCreate} className="btn btn-primary" data-testid="add-rejection-reason-btn"><Plus size={16} /> Add Reason</button>
      </div>
      <div className="card mb-4">
        <div style={{ position: 'relative' }}>
          <Search size={16} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-tertiary)' }} />
          <input type="text" className="form-input" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={{ paddingLeft: '40px' }} data-testid="search-input" />
        </div>
      </div>
      <div className="card">
        {loading ? <div>Loading...</div> : (
          <div className="table-container">
            <table>
              <thead><tr><th>Code</th><th>Reason</th><th>Category</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                {filtered.length === 0 ? <tr><td colSpan={5} style={{ textAlign: 'center', padding: '20px', color: 'var(--text-tertiary)' }}>No reasons found</td></tr> : filtered.map(d => (
                  <tr key={d.id}>
                    <td className="font-mono">{d.code}</td>
                    <td>{d.reason}</td>
                    <td><span className="badge badge-info">{d.category}</span></td>
                    <td><span className={`badge ${d.status === 'active' ? 'badge-success' : 'badge-danger'}`}>{d.status}</span></td>
                    <td>
                      <div className="flex gap-2">
                        <button onClick={() => openEdit(d)} className="btn btn-ghost btn-sm"><Edit size={14} /></button>
                        <button onClick={() => handleDelete(d.id, d.reason)} className="btn btn-ghost btn-sm"><Trash2 size={14} color="#DC2626" /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {showModal && (
        <div className="modal-overlay" data-testid="rejection-reason-modal">
          <div className="modal-content" style={{ maxWidth: '450px' }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header"><h2 style={{ margin: 0, fontSize: '18px', fontWeight: 700 }}>{editing ? 'Edit Reason' : 'Add Reason'}</h2></div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group"><label className="form-label">Reason *</label><input type="text" className="form-input" value={formData.reason} onChange={(e) => setFormData({...formData, reason: e.target.value})} required data-testid="reason-input" /></div>
                <div className="form-group">
                  <label className="form-label">Category</label>
                  <select className="form-select" value={formData.category} onChange={(e) => setFormData({...formData, category: e.target.value})} data-testid="category-select">
                    {categories.map(c => <option key={c} value={c}>{c.charAt(0).toUpperCase() + c.slice(1)}</option>)}
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" onClick={() => setShowModal(false)} className="btn btn-secondary">Cancel</button>
                <button type="submit" className="btn btn-primary" data-testid="submit-reason-btn">{editing ? 'Update' : 'Add'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default RejectionReasons;
